import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useT } from '../i18n/LanguageContext';
import seo from '../data/seo';

const SEO = () => {
  const { pathname } = useLocation();
  const { lang } = useT();

  const currentLang = ['fr', 'en', 'ar'].includes(lang) ? lang : 'fr';

  const pageSeo =
    seo[currentLang]?.[pathname] ||
    seo.fr?.[pathname] ||
    seo.fr['/'];

  useEffect(() => {
    const fullTitle = pageSeo.title;

    document.title = fullTitle;

    const setMeta = (name, content) => {
      let element = document.querySelector(`meta[name="${name}"]`);

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', name);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    const setProperty = (property, content) => {
      let element = document.querySelector(
        `meta[property="${property}"]`
      );

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', property);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    const cleanPath =
      pathname === '/' ? '' : pathname;

    const canonicalUrl =
      `https://www.gpefrance.eu/gpe${cleanPath}`;

    setMeta('description', pageSeo.description);

    setProperty('og:title', pageSeo.title);
    setProperty('og:description', pageSeo.description);
    setProperty('og:type', 'website');
    setProperty('og:url', canonicalUrl);

    setProperty('twitter:card', 'summary_large_image');
    setProperty('twitter:title', pageSeo.title);
    setProperty('twitter:description', pageSeo.description);

    let canonical = document.querySelector(
      'link[rel="canonical"]'
    );

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', canonicalUrl);

  }, [pathname, currentLang, pageSeo]);

  return null;
};

export default SEO;